import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
    selector: '[columnTemplate]',
    standalone: true,
})
export class ColumnTemplateDirective {
 @Input('columnTemplate') columnKey!: string;
  constructor(public templateRef: TemplateRef<any>) {
  }

}
